import { colors } from '../../colors';
var socialFeed = {
  postTextColor: colors.nvaBlack,
  primaryColor: colors.nvaTeal,
  feedBgColor: colors.white,
  headlineUppercase: false,
  subHeadlineUppercase: true
};
export default socialFeed;